// URL-safe Base64 → Uint8Array
export function urlBase64ToUint8Array(base64) {
  if (typeof base64 !== 'string' || !base64.length) return new Uint8Array(0);

  // URL-safe → 標準 Base64 に変換
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');

  // atob が無い環境はほぼ無いが、念のため polyfill
  const _atob = typeof atob === 'function'
    ? atob
    : (str) => Buffer.from(str, 'base64').toString('binary');

  const binary = _atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}